import { ReactComponent as CopyIcon } from "@/assets/voice_understand/copy_icon.svg?react";
import { ReactComponent as ShareIcon } from "@/assets/voice_understand/share_icon.svg?react";
import { ReactComponent as EditIcon } from "@/assets/voice_understand/edit_icon.svg?react";
import { ReactComponent as DownloadIcon } from "@/assets/voice_understand/download_icon.svg?react";
import { ReactComponent as LikeIcon } from "@/assets/voice_understand/like_icon.svg?react";
import { ReactComponent as DislikeIcon } from "@/assets/voice_understand/dislike_icon.svg?react";

export const ActionIcons = {
  copy: CopyIcon,
  share: ShareIcon,
  edit: EditIcon,
  download: DownloadIcon,
  like: LikeIcon,
  dislike: DislikeIcon,
} as const;
